<template>
	<div class="tab-pane active">
        <div id="accordion" class="accordion">
            <div class="card mb-0 border-0">
                <div class="accordion-border border-0 bg-white mb-0" v-for="list,index in 8">
                    <div class="card-header collapsed border-0 bg-white p-0" @click="changeIndex(index)">
                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                            <div class="Program d-flex align-items-center">
                                <i class="icon icon-prescription"></i>
                                <div class="Diebetes">
                                    <h6>Program</h6>
                                    <p>Diebetes</p>
                                </div>
                            </div>
                            <div class="dr-history d-flex">
                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                <div class="dr-history">
                                    <h6>Name</h6>
                                    <h3>Dr. Shabnam Das Kar</h3>
                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                </div>
                            </div>
                            <div class="intake">
                                <a href="#">
                                    <h6>Date</h6>
                                    <p>13 May 2021, to 13 June 2021</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body collapse p-0 border-0 medicine-current show" v-if="indexSelected == index">
                        <div class="table-responsive">
                            <table class="table Medicine-list mb-0 border-0" border="0" cellspacing="0" cellpadding="0">
                                <thead>
                                    <tr>
                                        <th>Medicine Name</th>
                                        <th>Dosage</th>
                                        <th>Duration</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span>1. Ceruvin 75</span></td>
                                        <td>2 times(Morning and Evening )</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product" class="btn btn-blue Analyze-medicine">Analyze your medicine</router-link></td>
                                    </tr>
                                    <tr>
                                        <td><span>2. Azulix O MF Forte </span></td>
                                        <td>1 Time (Morning before brekfast)</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product" class="btn btn-blue Analyze-medicine">Analyze your medicine</router-link></td>
                                    </tr>
                                    <tr>
                                        <td><span>3. Neksium 40</span></td>
                                        <td>1 Time (Before Lunch)</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product" class="btn btn-blue Analyze-medicine">Analyze your medicine</router-link></td>
                                    </tr>
                                    <tr>
                                        <td><span>4. Tazloc-20, </span></td>
                                        <td>2 times(Morning and Evening )</td>
                                        <td>10 Days, Total Tablet : 10</td>
                                        <td><router-link to="/prescription-product" class="btn btn-blue Analyze-medicine">Analyze your medicine</router-link></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row no-gutters p-3 align-items-center justify-content-between">
                            <div class="col-md-9 d-flex notes border-radius-5 p-3">
                                <h3>Suggestion:</h3>
                                <div>
                                    <div class="row no-gutter">
                                        <div class="col-lg-6">
                                            <p><i class="icon icon-check"></i>No gluten containing food.</p>
                                            <p><i class="icon icon-check"></i>Repeat Gut q after 2 weeks of no gluten.</p>
                                            <p><i class="icon icon-check"></i>Add ghee, nuts.</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <p><i class="icon icon-check"></i>No gluten containing food.</p>
                                            <p><i class="icon icon-check"></i>Repeat Gut q after 2 weeks of no gluten.</p>
                                            <p><i class="icon icon-check"></i>Add ghee, nuts.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "prescription",
        data() {
            return {
              indexSelected:-1
            };
        },
        methods:{
        	changeIndex(index){
        		if(this.indexSelected == index){
        			this.indexSelected = -1
        		}else{
        			this.indexSelected = index
        		}
        	}
        }
        
    };
</script>


// WEBPACK FOOTER //
// src/components/website/prescription/past-prescription.vue